// DS: PO63
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Button from '../Button';
import Flex from '../Flex';
import { ReverseTheme, MobileContext } from '../Context';
import s from './SisuFunnelBanner.scss';
var SisuFunnelBanner = function (_a) {
    var visible = _a.visible;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(Flex, { className: classnames(s['root'], visible && s['root-visible']), alignItems: "center", justifyContent: "center", direction: isMobile ? 'column' : 'row' },
        React.createElement("span", { className: s['text'] }, t('sisuFunnel.text')),
        React.createElement(ReverseTheme, { className: s['buttons'] },
            React.createElement(Button, { href: Url.loginLink(), view: "b14-1", className: classnames(s['button'], s['login']), fullWidth: false }, t('sisuFunnel.login')),
            React.createElement(Button, { href: Url.joinLink(), view: "b1-1", className: s['button'], fullWidth: false }, t('sisuFunnel.join')))));
};
export default SisuFunnelBanner;
//# sourceMappingURL=SisuFunnelBanner.js.map